import React from 'react';
import ReactDOM from 'react-dom';

const rootEl = document.getElementById('app-site');

// Create a reusable render method that we can call more than once
let render = (a : any,s:any) => {
  // Dynamically import our main App component, and render it
  const MainApp = require('./MainApp').default;
  ReactDOM.render(
    <MainApp/>,
    rootEl
  );
};

const anyModule = module as any;

if (anyModule['hot']) {
  anyModule['hot'].accept('./MainApp', () => {
    const MainApp = require('./MainApp').default;
    render(
      <MainApp/>, rootEl
    );
  });
}

render(null, null);
